const p = {
  TOTAL_COMPLETED: "nTotalCompleted",
  TOTAL_MISSING: "nTotalMissing",
  LAST_MISSING: "nTotalMissingPrev1Week",
  LAST_COMPLETED: "nTotalCompletedPrev1Week",
  TOTAL_QUERY: "totalQuery",
  TOTAL_QUERY_LAST_WEEK: "totalQueryPrev1Week",
  TOTAL_DATA_CHANGE: "totalDataChange",
  TOTAL_DATA_CHANGE_LAST_WEEK: "totalDataChangePrev1Week"
};

const excludeActivities = ["eConsent", "eConsent Comprehension Quiz", "Agreement Document", "Queries"];

function getMissingData(raw, countries = [], sites = []) {
  let currentMissing = 0;
  let lastMissing = 0;
  let totalPoint = 0;
  let totalLastPoint = 0;

  let nMissing = 0;
  let nCompleted = 0;
  let nLastMissing = 0;
  let nLastCompleted = 0;

  if (!raw) {
    return { currentMissing, lastMissing, totalPoint, totalLastPoint };
  }

  Object.keys(raw).forEach(activities => {
    if (excludeActivities.indexOf(activities) < 0) {
      for (const countryName of countries) {
        if (raw[activities] && raw[activities][countryName]) {
          const countryData = raw[activities][countryName];

          for (const siteName of sites) {
            if (countryData[siteName]) {
              const siteData = countryData[siteName];

              nMissing += parseInt(siteData[p.TOTAL_MISSING] || 0);
              nCompleted += parseInt(siteData[p.TOTAL_COMPLETED] || 0);
              nLastMissing += parseInt(siteData[p.LAST_MISSING] || 0);
              nLastCompleted += parseInt(siteData[p.LAST_COMPLETED] || 0);
            }
          }
        }
      }
    }
  });

  // Get current missing data
  totalPoint = nMissing + nCompleted;
  const missData = Number((nMissing / totalPoint) * 100).toFixed(0);

  // Get last missing data
  totalLastPoint = nLastMissing + nLastCompleted;
  const lassMissData = Number((nLastMissing / totalLastPoint) * 100).toFixed(0);

  currentMissing = parseInt(missData || 0);
  lastMissing = parseInt(lassMissData || 0);

  return { currentMissing, lastMissing, totalPoint, totalLastPoint };
}

function getTotalQuery(r, countries = [], sites = []) {
  let currentQuery = 0;
  let lastQuery = 0;

  if (!r) {
    return { currentQuery, lastQuery };
  }

  for (const countryName of countries) {
    if (!(countryName in r)) {
      continue;
    }

    const countryData = r[countryName];

    for (const siteName of sites) {
      if (!(siteName in countryData)) {
        continue;
      }

      const s = countryData[siteName];

      currentQuery += parseInt(s[p.TOTAL_QUERY] || 0);
      lastQuery += parseInt(s[p.TOTAL_QUERY_LAST_WEEK] || 0);
    }
  }

  currentQuery = parseInt(currentQuery || 0);
  lastQuery = parseInt(lastQuery || 0);

  return { currentQuery, lastQuery };
}

function getTotalDataChange(r, countries = [], sites = []) {
  let currentDataChange = 0;
  let lastDataChange = 0;

  if (!r) {
    return { currentDataChange, lastDataChange };
  }

  for (const countryName of countries) {
    if (!(countryName in r)) {
      continue;
    }

    const countryData = r[countryName];

    for (const siteName of sites) {
      if (!(siteName in countryData)) {
        continue;
      }

      const s = countryData[siteName];

      currentDataChange += parseInt(s[p.TOTAL_DATA_CHANGE] || 0);
      lastDataChange += parseInt(s[p.TOTAL_DATA_CHANGE_LAST_WEEK] || 0);
    }
  }

  currentDataChange = parseInt(currentDataChange || 0);
  lastDataChange = parseInt(lastDataChange || 0);

  return { currentDataChange, lastDataChange };
}

export { getMissingData, getTotalQuery, getTotalDataChange };
